import { Container } from "components";

import classes from "./AgentDashboard.module.css";
import CalendarSection from "./CalendarSection";
import CallWidgetSection from "./CallWidgetSection";
import GreetingSection from "./GreetingSection";
import KpiSection from "./KpiSection";
import MessagesSection from "./MessagesSection";
import TodoSection from "./TodoSection";

const AgentDashboard = () => (
  <Container>
    <div className={classes.page}>
      <div className={classes.layout}>
        <GreetingSection className={`${classes.section} ${classes.greeting}`} />

        <div className={classes.leftColumn}>
          <div className={`${classes.section} ${classes.kpis}`}>
            <KpiSection />
          </div>

          <div className={`${classes.section} ${classes.todo}`}>
            <TodoSection />
          </div>
        </div>

        <div className={`${classes.section} ${classes.call}`}>
          <CallWidgetSection />
        </div>

        <div className={`${classes.section} ${classes.calendar}`}>
          <CalendarSection />
        </div>

        <div className={`${classes.section} ${classes.messages}`}>
          <MessagesSection />
        </div>
      </div>
    </div>
  </Container>
);

export default AgentDashboard;
